module.exports = __webpack_public_path__ + "img/docx.deda4991.png";